module.exports = __webpack_public_path__ + "static/media/newGarbageIcon.8fe7e418.svg";